/* KHC assistant UI shim (v10): options menu + reply wording. Runs after khc-assist.js; touches nothing else. */
(function () {
  'use strict';
  /* wording fixes for replies written before the topic buttons were removed and before the AED 31.50 flat rate was added */
  var FIXES = [
    ['You can pick a topic below or type', 'You can type'],
    ['Delivery cost and timing depend on your location and the products, so I cannot promise a delivery time here. Send us your area and the product and our team will confirm.',
     'Delivery within the UAE is a flat AED 31.50 and takes 1 to 2 business days after your order is processed (Monday to Saturday, no Sunday or public holiday delivery). Our team can help on WhatsApp if you need more.']
  ];
  function fixText(node) {
    var w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    var t;
    while ((t = w.nextNode())) {
      for (var i = 0; i < FIXES.length; i++) {
        if (t.nodeValue.indexOf(FIXES[i][0]) > -1) t.nodeValue = t.nodeValue.replace(FIXES[i][0], FIXES[i][1]);
      }
    }
  }
  function init() {
    var root = document.querySelector('[data-khc-ai]');
    if (!root) return;
    var btn = root.querySelector('[data-ai-menu]');
    var menu = root.querySelector('[data-ai-menupanel]');
    var log = root.querySelector('[data-ai-log]');
    function setMenu(open) {
      if (!btn || !menu) return;
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (btn && menu) {
      btn.addEventListener('click', function (e) { e.stopPropagation(); setMenu(menu.hidden); });
      document.addEventListener('click', function (e) { if (!menu.hidden && !menu.contains(e.target)) setMenu(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { setMenu(false); btn.focus(); } });
      menu.addEventListener('click', function (e) {
        var n = e.target.closest('[data-ai-new]');
        setMenu(false);
        if (n) {
          if (log) log.innerHTML = '';
          var h = root.querySelector('[data-ai-home-btn]');
          if (h) h.click();
          var i = root.querySelector('[data-ai-input]');
          if (i) i.focus({ preventScroll: true });
        }
      });
    }
    if (log && window.MutationObserver) {
      new MutationObserver(function (list) {
        list.forEach(function (m) {
          m.addedNodes.forEach(function (n) { if (n.nodeType === 1) fixText(n); });
        });
      }).observe(log, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();